import React from 'react';
import {FormControl, ControlLabel, FormGroup} from 'react-bootstrap';
import HelpHintButton from 'components/HelpHintButton';

export const LANGUAGE = 'lang';
export const LANG_RU = 'ru';
export const LANG_EN = 'en';

export const languageOptions = {
    [LANG_RU]: 'Русский',
    [LANG_EN]: 'Английский',
};

const WidgetLanguageSetting = ({lang, onUpdate}) => {
    return (
        <FormGroup>
            <ControlLabel>
                Язык интерфейса
                <HelpHintButton>
                    Язык интерфейса выбирается автоматически исходя из настроек браузера. Так-же язык можно задать принудительно.
                </HelpHintButton>
            </ControlLabel>
            <FormControl
                value={lang || ""}
                componentClass="select"
                name={LANGUAGE}
                onChange={(e) => onUpdate(LANGUAGE, e.target.value)}
            >
                <option key={"auto"} value={""}>Авто</option>
                {
                    Object.entries(languageOptions).map(([key, name]) => (
                        <option key={key} value={key}>{name}</option>
                    ))
                }
            </FormControl>
        </FormGroup>
    );
};

export default WidgetLanguageSetting;
